import { PAYMENTS_API_URL } from 'data/constants';
import { DepositPaymentPage } from 'data/payments/paymentPage';

/** The payment page of the deposit's method as data; `page: null` — the old page. */
export async function getPaymentPage(depositId: string) {
  const response = await fetch(
    `${PAYMENTS_API_URL}/public/payments/${depositId}/page`,
    { method: 'GET', headers: { 'Content-Type': 'application/json' } },
  );
  if (response.status > 399)
    throw new Error(`Failed to get the payment page: ${response.status}`);

  return DepositPaymentPage.parse(await response.json());
}
